document.addEventListener('DOMContentLoaded', () => {
  class MeganticSidebar extends HTMLElement {
    connectedCallback() {
      const headers = this.querySelectorAll('[data-header]');
      console.log('MeganticSidebar initialized. Headers found:', headers.length);

      headers.forEach(header => {
        header.addEventListener('click', () => {
          const id = header.dataset.id;
          const content = this.querySelector(`[data-content][data-id="${id}"]`);
          if (content) {
            content.toggleAttribute('open');
            console.log(`Toggled section: ${id}`);
          }
        });
      });
    }
  }

  if (!customElements.get('megantic-sidebar')) {
    customElements.define('megantic-sidebar', MeganticSidebar);
    console.log('MeganticSidebar defined');
  }
});
